/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderDiscountCalculation = {
    FIXED_AMOUNT: 'FIXED_AMOUNT',
    PERCENTAGE: 'PERCENTAGE'
} as const;
export type OrderDiscountCalculation = typeof OrderDiscountCalculation[keyof typeof OrderDiscountCalculation];


export function instanceOfOrderDiscountCalculation(value: any): boolean {
    for (const key in OrderDiscountCalculation) {
        if (Object.prototype.hasOwnProperty.call(OrderDiscountCalculation, key)) {
            if (OrderDiscountCalculation[key as keyof typeof OrderDiscountCalculation] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrderDiscountCalculationFromJSON(json: any): OrderDiscountCalculation {
    return OrderDiscountCalculationFromJSONTyped(json, false);
}

export function OrderDiscountCalculationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDiscountCalculation {
    return json as OrderDiscountCalculation;
}

export function OrderDiscountCalculationToJSON(value?: OrderDiscountCalculation | null): any {
    return value as any;
}

export function OrderDiscountCalculationToJSONTyped(value: any, ignoreDiscriminator: boolean): OrderDiscountCalculation {
    return value as OrderDiscountCalculation;
}

